// Components==============
import {
    faCircle,
    faPaperPlane,
    faSquare,
    faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import storeAudiomessage from 'actions/audiomessage/store';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { motion, useAnimation } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { HomeContext } from 'screens/Home/Home';
import { HomeworkContext } from 'screens/Homework/Homework';
import useSound from 'use-sound';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import { RecordVoiceAudios } from 'utilities/RecordVoiceAudios';
import { MenuContext } from '../../Menu';
import CirclesBar from '../CirclesBar/CirclesBar';
import Popup from '../Popup/Popup';
import './Microphone.module.scss';
// =========================

const variants = {
    initial: {
        x: '100%',
    },
    recording: {
        x: '0%',
        transition: {
            duration: 30,
            ease: 'linear',
        },
    },
    stopped: {},
};

export default function Microphone() {
    const { select, selected, setMenuPointer } = useContext(MenuContext);
    const [recording, setRecording] = useState(false);
    const [recordingFinished, setRecordingFinished] = useState(false);
    const [file, setFile] = useState(null);
    const [play] = useSound('/audio/hond.wav');
    const dispatch = useDispatch();

    const controls = useAnimation();
    const location = useLocation();
    const routeParams = useParams();

    const { sequence } = useContext(HomeworkContext);

    function recordingDone(localFile) {
        controls.stop();
        setFile(localFile);
    }

    function resetRecording() {
        controls.start('initial');
        setRecording(false);
        setRecordingFinished(false);
        setFile(null);
    }

    function storeRecording() {
        if (recordingFinished) {
            play();
        }

        let parsedLocation = '';
        let treatmentId;
        let exerciseId;

        if (location.pathname === '/') {
            parsedLocation = 'Startpagina';
        } else if (location.pathname.includes('homework')) {
            treatmentId = routeParams.treatmentId;
            parsedLocation = sequence || 'homework';
            exerciseId = routeParams.homeworkId;
        } else if (location.pathname.includes('audio-exercise')) {
            parsedLocation = 'audio';
            treatmentId = routeParams.treatmentId;
            exerciseId = routeParams.exerciseId;
        } else if (location.pathname.includes('flitsprogramma')) {
            parsedLocation = 'flash';
            treatmentId = routeParams.treatmentId;
            exerciseId = routeParams.exerciseId;
        }

        let data = {
            file,
            location: parsedLocation,
        };

        if (exerciseId) {
            data = {
                ...data,
                exercise_id: exerciseId,
            };
        }
        if (treatmentId) {
            data = {
                ...data,
                treatment_id: treatmentId,
            };
        }

        dispatch(storeAudiomessage(data));
        resetRecording();
    }

    const [recorder] = useState(
        new RecordVoiceAudios(recordingDone, setRecording, setRecordingFinished)
    );

    window.URL = window.URL || window.webkitURL;
    /**
     * Detecte the correct AudioContext for the browser
     * */
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

    function recordClick() {
        console.log('Record click');
        console.log(recorder);
        if (recording) {
            recorder.stopRecord();
            // setRecording(false);
        } else if (recordingFinished) {
            resetRecording();
        } else {
            recorder.startRecord();
        }
        // setRecording(true);
    }

    useEffect(() => {
        if (recording === true) {
            controls.start('recording');
        } else {
            controls.stop();
        }
    }, [recording]);

    const { setWelcomeY, welcomeSequence } = useContext(HomeContext);

    const ref = useRef(null);

    useEffect(() => {
        if (welcomeSequence === 'mic') {
            setWelcomeY(`${ref?.current?.offsetTop}px`);
        }
    }, [welcomeSequence]);

    return (
        <div styleName="wrapper" ref={ref}>
            <motion.button
                animate={welcomeSequence === 'mic' ? pulse : initialPulse}
                initial={initialPulse}
                onClick={(e) => {
                    select('microphone');
                    setMenuPointer(e);
                    controls.start('initial');
                    setRecording(false);
                }}
                type="button"
            >
                <img
                    alt="city icon"
                    src={`/images/menu/icon-microphone${
                        selected === 'microphone' ? '-active' : ''
                    }.svg`}
                />
            </motion.button>
            {selected === 'microphone' && (
                <Popup
                    translateY50
                    style={{
                        background: '#181818',
                        top: '50%',
                        padding: '0px',
                    }}
                >
                    <CirclesBar>
                        <motion.div
                            initial="initial"
                            animate={controls}
                            variants={variants}
                            styleName="progress"
                        />
                        <CircleButton color="white" onClick={recordClick}>
                            <FontAwesomeIcon
                                styleName={`${recording ? 'blue' : 'red'}`}
                                icon={
                                    recording
                                        ? faSquare
                                        : recordingFinished
                                        ? faTrash
                                        : faCircle
                                }
                            />
                        </CircleButton>
                        <CircleButton color="white" onClick={storeRecording}>
                            <FontAwesomeIcon
                                styleName={` ${
                                    recordingFinished
                                        ? 'blue send-recording recordingInMemory'
                                        : 'blue send-recording'
                                }`}
                                icon={faPaperPlane}
                            />
                        </CircleButton>
                    </CirclesBar>
                </Popup>
            )}
        </div>
    );
}
